// /**
//  * Sample Calling Schema
//  *    <CgDropdown
//          dropdownOptions={[
//            { id: 0, value: "None", metadata: { specialty: "Heart", location: "LA", code: "002" },},
//            { id: 1, value: "Jr" , metadata: { specialty: "Heart", location: "LA", code: "002" },},
//            { id: 2, value: "Jr 1" , metadata: { specialty: "Heart", location: "LA", code: "002" },},
//          ]}
//          required={true}
//          onSelectCallBack={(value) => {
//            console.log(value);
//          }}
//          defaultValue={"Jr 1"}
//        />
//  */

import React, { useEffect, useState } from "react";
import "./cgDropdown.scss";
const CgDropdown = ({
  dropdownOptions,
  onSelectCallBack,
  required,
  label,
  name,
  defaultValue,
  resetValue,
  dropdownClassName,
  dropdownPlaceHolder,
  disabled = false, // disbale field
  renderCustomError, // boolean value
  customErrorMsg, // string
  alwaysShowPlaceholder = false,
}) => {
  const [selectedValue, setSelectedValue] = useState();
  const [isInteracted, setIsInteracted] = useState(false);
  const [onFocus, setOnFocus] = useState(false);

  useEffect(() => {
    if (resetValue && !defaultValue) {
      setSelectedValue("");
    } else {
      setSelectedValue(defaultValue);
    }
  }, [resetValue, defaultValue]);

  useEffect(() => {
    if (!defaultValue) {
      setSelectedValue(defaultValue);
    }
  }, [defaultValue]);

  const handleChange = (e) => {
    const value = e.target.value;
    setSelectedValue(value);
    setIsInteracted(true);

    const selectedItem = dropdownOptions.find((item) => item.value === value);

    if (onSelectCallBack) {
      onSelectCallBack(name, value, selectedItem);
    }
    setOnFocus(false);
  };

  const handleBlur = () => {
    setIsInteracted(true);
    setOnFocus(false);
  };
  const handleOnFocus = () => {
    setOnFocus(true);
  };

  return (
    <>
      <div
        className={`${
          dropdownClassName ? dropdownClassName : "cgDropdownWrapper"
        }`}
      >
        {label && <label className="form-label">{label}</label>}
        <select
          className={`form-select ${
            required && isInteracted && !selectedValue
              ? "form-select error"
              : ""
          } ${renderCustomError ? "form-control error" : ""}  ${
            onFocus ? "form-select onFocus" : ""
          }`}
          aria-label="Default select example"
          value={alwaysShowPlaceholder ? "" : selectedValue || defaultValue}
          onChange={handleChange}
          onBlur={handleBlur}
          onFocus={handleOnFocus}
          name={name}
          disabled={disabled}
        >
          <option value="">
            {dropdownPlaceHolder ? dropdownPlaceHolder : ""}
          </option>
          {dropdownOptions.map((dropdownItem, index) => (
            <option value={dropdownItem.value} key={index}>
              {dropdownItem.value}
            </option>
          ))}
        </select>
      </div>
      {customErrorMsg && (
        <div className="commonCustomErrorMsg"> {customErrorMsg} </div>
      )}
    </>
  );
};
export default CgDropdown;
